/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DetalhesAutorizacaoAliases {
  ACTION_IMPRIMIR = 'action-imprimir',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  CONTEXTUAL_BAR_2 = 'contextual-bar-2',
  CONTEXTUAL_BAR_3 = 'contextual-bar-3',
  CUSTOM_CARD_ITEM = 'custom-card-item',
  DECK_0 = 'deck-0',
  DECK_ANEXOS = 'deck-anexos',
  FETCH_1 = 'fetch-1',
  FETCH_ANEXOS = 'fetch-anexos',
  FETCH_AUTORIZACAO = 'fetch-autorizacao',
  FETCH_GLOSAS_OCORRENCIAS = 'fetch-glosas-ocorrencias',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_14 = 'field-14',
  FIELD_15 = 'field-15',
  FIELD_16 = 'field-16',
  FIELD_17 = 'field-17',
  FIELD_18 = 'field-18',
  FIELD_19 = 'field-19',
  FIELD_20 = 'field-20',
  FIELD_21 = 'field-21',
  FIELD_22 = 'field-22',
  FIELD_29 = 'field-29',
  FIELD_30 = 'field-30',
  FIELD_31 = 'field-31',
  FIELD_ODONTO = 'field-odonto',
  FORM_DADOS = 'form-dados',
  FRAGMENT_0 = 'fragment-0',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  IMAGE_0 = 'image-0',
  LAYOUT_DETALHES_AUTORIZACAO = 'layout-detalhes-autorizacao',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AVATAR = 'mapper-avatar',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_ANEXOS = 'panel-anexos',
  PANEL_AUTORIZACAO = 'panel-autorizacao',
  PANEL_GLOSAS_OCORRENCIAS = 'panel-glosas-ocorrencias',
  PANEL_LOADER = 'panel-loader',
  REPEATER_0 = 'repeater-0',
  TAB_ANEXOS_TISS = 'tab-anexos-tiss',
  TAB_CONTROL_AUTORIZACAO = 'tab-control-autorizacao',
  TAB_DADOS_AUTORIZACAO = 'tab-dados-autorizacao',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_17 = 'text-17',
  TEXT_18 = 'text-18',
  TEXT_19 = 'text-19',
  TEXT_23 = 'text-23',
  TEXT_24 = 'text-24',
  TEXT_26 = 'text-26',
  TEXT_221 = 'text-221',
  TEXT_231 = 'text-231',
  TEXT_241 = 'text-241',
  TEXT_ODONTO = 'text-odonto',
}
export { DetalhesAutorizacaoAliases };
